import requests from "./requests";
import schedules from "./schedules";

export default {
    requests,
    schedules,
};
